module.exports = __webpack_public_path__ + "static/level_5.ee1cc47e.png";